module.exports = {
  "FoodB_2_Please_select_Mixz": "選択してください",
  "FoodC_intostore_Store_Coupon_kHwh": "店舗クーポン",
  "FoodOpB_management_Special_rules_PdhA": "特殊規則",
  "FoodB_Commision_Add_MPEf": "追加",
  "FoodB_tagging_You_chose_OMGB": "無効リーズの理由として「店舗が存在しない」を選択する場合は、写真のアップロードが必要です。",
  "FoodC_homepage_Enter_delivery_IZAu": "お届け先住所を入力",
  "FoodOpB_management104_Coordinator_endx": "コーディネーター",
  "Help_V4_Enter_the_xqlm": "携帯電話番号を入力してください",
  "FoodC_Card2_When_the_sFOa": "受付開始時間",
  "FoodOpB_1_Expired_rTXx": "期限切れ",
  "FoodB_Show_Store_Direct_GuJM": "店舗セルフ契約",
  "FoodOpB_Management_Appeals_foxk": "申し立て",
  "soda-c-i18n---个人中心的“优惠券”": "DiDi Foodアカウントの「クーポン」。",
  "FoodC_sales_Confirmation_mTGd": "確認",
  "FoodOpB_v2_Data_update_YmPK": "データ更新日時",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1、遅延補填は%sがお客様に提供しているサービスです。ご注文の商品（キャンセルした注文は除く）が予定配達時刻以内に配達されなかった場合、%sよりお詫びとしてクーポンを差し上げます。注文完了後×にてご確認できます。",
  "FoodB_v1_Sources_of_DsXR": "情報ソース",
  "FoodC_education_1_Customers_Gpbb": "1. ご注文確定前に受取方法を選択できます。配達員は、お客様が選択した受取方法に従ってお届けします。",
  "soda-c-i18n---现金": "現金",
  "soda-c-i18n---将赔付给您1张%s优惠券": "遅延補填として%sの配達料無料クーポンを1枚差し上げます",
  "FoodD_payout_Account_Type_YmVW": "口座種別",
  "FoodOpB_system_offline_ersI": "オフラインでの運営状況",
  "FoodB_V2_Illegal_companies_pXwb": "非合法企業",
  "FoodOpB_1_New_visits_HXsz": "訪問記録を作成",
  "FoodC_sidebar_Scan_QR_ONzJ": "携帯電話のカメラでQRコードをスキャンしてください",
  "FoodC_sidebar_Use_the_huoZ": "アプリを使って、グルメを楽しもう",
  "FoodB_management_Automatic_Switching_ghJS": "自動注文受付開始・停止",
  "FoodC_education_3_If_wduh": "3. 商品の問題、天候の問題など人為的なもの以外の原因で受取の問題が発生した場合は、プラットフォームが責任を負います。",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "対応係数",
  "FoodOpB_tool_Category_main_aHZl": "メインカテゴリー",
  "FoodB_audit_Store_Information_ryuV": "店舗情報編集の審査",
  "FoodB_list_Recently_launched_IWDa": "直近のオンライン時間",
  "FoodOpB_1_Seven_days'_LZwW": "7日以内に訪問",
  "FoodOpB_1_Close_visit_ttxh": "訪問中止の確認",
  "FoodB_SMS__promotion_EKZy": "配達料金割引イベント",
  "FoodC_education_Platform_Delivery_MJPQ": "DiDi Food配達",
  "FoodB_management_Name_of_EjQd": "直属上司のSSOアカウント",
  "FoodB_audit_Review_process_vGtV": "審査プロセスが開始されます。確定しますか？",
  "FoodC_dish_Look_again_fJrp": "いいえ",
  "FoodC_nonaffiliate_Courier_is_iunG": "配達員がお店に向かっています",
  "必选": "必須",
  "FoodB_Show_Tax_payment_xfxh": "納税方法（全国）",
  "确认": "確認",
  "FoodC_education_3_Customers_Zoec": "3. 配達員から連絡が取りやすいよう、常に電話がつながる状態にしておいてください。",
  "bill-manage---no_auth": "不足な権限",
  "FoodB_2_Store_XkLQ": "店舗",
  "FoodC_web_Application_Progress_UYtG": "払い戻し申請状況",
  "FoodB_tagging_You_chose_aZCG": "無効リーズの理由として「閉店」を選択しましたが、現在の位置は店舗から{{distance}}離れています。ご確認ください。",
  "FoodC_education__1_vwgm": "(1) 玄関先で受け取る",
  "FoodC_perception_Tips_hZWk": "チップ",
  "FoodB_audit_Similarity_check_cQEP": "類似度チェック",
  "FoodC_supplement_Return_wVpv": "戻る",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "受取ルール",
  "FoodC_revision_Contact_customer_XbFk": "カスタマーセンターへ連絡",
  "FoodOpB_Management_High_similarity_lnFn": "類似性の高い店舗があります",
  "FoodB_5_Store_Delivery_PIyN": "店舗配達",
  "FoodC_education_5_Cash_zBuY": "5. 現金支払いの場合は、十分な現金をご用意ください。",
  "FoodB_management_Role_yLYi": "役職",
  "FoodOpB_Tool_Supplies_Vptd": "アイテム",
  "FoodOpB_system_DiDi_XcUY": "DiDiでの運営状況",
  "FoodOpB_2_Activity_status_hKFd": "キャンペーンステータス",
  "FoodB_list_Name_of_dxYm": "担当営業の氏名",
  "soda-c-i18n---送您1张%s优惠券；": "%sのクーポンを1枚差し上げます。",
  "FoodOpB_management_Indicators_BzjD": "指標",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "閉じる",
  "FoodC_remark_Thank_you_ENoY": "{{brand_name}}をご利用いただきありがとうございました",
  "FoodOpB_1_Information_gathering_pIHo": "内諾後情報回収／アフターサポート",
  "FoodC_dish_Leaving_LwWJ": "はい",
  "FoodC_dish_Current_activity_Iyrv": "こちらのキャンペーンはあと{{arrived_time}}で終了します。終了後、初回注文特典スペシャルディッシュはご注文いただけなくなります。",
  "FoodB_optimization_Full_reduction_NlOa": "注文金額に応じた割引",
  "FoodC_dish_You_will_AXAT": "このページを離れると初回注文特典スペシャルディッシュはご注文いただけなくなります。",
  "FoodB_data_End_mVwX": "終了日",
  "soda-c-i18n---晚间：%s-%s": "夜間：%s-%s",
  "FoodB_2_Online_visit_OLuR": "ウォークイン",
  "FoodOpB_1_Visit_Details_fMYD": "訪問詳細",
  "FoodC_education_1_If_iWDm": "1. お客様が上記のルールに沿ってご注文を受け取らなかったことによって、問題が発生した場合、まずお客様側の責任として対応します。具体的には、次のような場合があります（ただしこれらの例に限りません）。",
  "FoodB_audit_Audit_process_asoS": "審査プロセスが開始され、審査が完了するまで契約の申請ができません。確定しますか？",
  "FoodB_V2_No_legal_QONX": "代表者の本人確認書類なし",
  "FoodB_Commision_Type_of_EIWZ": "店舗タイプ",
  "FoodB_NewStore_Status_HphC": "ステータス",
  "FoodB_list_Store_Phone_tSWo": "店舗の電話番号",
  "FoodB_Show_Savings_uvSS": "定期預金",
  "FoodOpB_1_Visiting_hours_yAJS": "訪問日時",
  "FoodB_optimization_Label_nzNw": "タグ",
  "FoodB_leads_Artificial_labcategory_UNzu": "手動でタグ付けされたカテゴリー",
  "FoodD_supplement_Small_time_ycjv": "時間",
  "FoodB_list_Store_ID_GNUR": "店舗ID",
  "FoodB_system_offline_revV": "オフラインでの運営状況",
  "FoodOpB_Tool_Visit_szxD": "リンクにアクセス",
  "FoodB_address_Submission_cfyI": "送信",
  "FoodOpC_Notifications_Are_you_DIlk": "削除してよろしいですか？",
  "FoodOpB_manage_Details_IfVh": "詳細",
  "FoodB_reason_Contact_Courier_Fqog": "配達員へ連絡",
  "FoodB_list_Setting_Up_YlBy": "",
  "FoodB_list_Brand_Name_pGTc": "ブランド名",
  "sailing.d-api.common.页面获取失败，请稍后重试": "ページを取得できませんでした。後ほどお試しください",
  "FoodOpB_management_Actual_integral_xbDD": "実際ポイント",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "注文商品（キャンセルした注文は除く）が予定配達時刻以内に配達されなかった場合、%sより一定額のクーポンを差し上げます。注文完了後に次の箇所で確認できます：",
  "FoodB_I_Home_OrRo": "トップページ",
  "FoodOpB_information_The_selected_LyoI": "選択した銀行では決済ができません",
  "FoodC_web_Customer_Service_EBqf": "カスタマーセンター",
  "FoodD_Compliance_About_to_fTcV": "もうすぐ期限切れ",
  "FoodC_supplement_Modify_Mobile_ZJkT": "携帯電話番号の変更/パスワードの変更/メールアドレスの登録/アカウントの削除を行うには",
  "FoodD_supplement_Rules_RYAa": "判定ルール",
  "FoodB_tagging_You_chose_DSiT": "無効リーズの理由として「閉店」を選択する場合は、写真のアップロードまたはKP電話の入力が必要です。",
  "FoodD_up_DiDi_Delivery_FdmM": "DiDi配達",
  "FoodC_web_Only_1_ZddK": "1点限り",
  "soda-c-i18n---将赔付给您%s张免配送费券": "遅延補填として%s枚の配達料無料クーポンを差し上げます",
  "FoodC_all_You_haven_lSmt": "まだお友達を紹介していません。今すぐ紹介しましょう",
  "FoodC_education__3_TDsa": "(3) お客様が商品の受取を拒否した",
  "FoodC_education_2_If_SoSk": "2. 配達員がプラットフォーム規定に従ってご注文のお届けを完了せず、それにより受取の問題が発生した場合は、まず配達員の責任として対応します。",
  "FoodC_education__unk_aOCD": "{{delivery_type}}プラットフォーム規則",
  "FoodOpB_app_Need_for_inMl": "さらに交渉が必要",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "実際の配達時間が予定配達時刻より%s分以上遅れた場合、",
  "soda-c-i18n---取消订单": "注文をキャンセルする",
  "请选择支付方式": "決済方法をお選びください",
  "小费": "チップ",
  "FoodB_Part1_Store_Name_jrHD": "店舗名",
  "sailing.crm-intl.普通": "普通",
  "FoodC_education__2_jwSo": "(2) 玄関先に置く（備考欄に記入）",
  "FoodD_page_Manual_Accept_jCTW": "手動注文受付",
  "FoodB_Show_Subject_Information_RFOj": "契約主体情報",
  "FoodC_dish_Are_you_TaUN": "このページを離れますか？",
  "FoodOpB_10_Order_volume_WNmq": "注文数",
  "FoodC_web_Feedback_on_ookM": "現在のところ、Web版では関連する問題のフィードバックに対応していません。携帯電話のアプリで操作してください。ご不便をおかけしまして大変申し訳ございません。ご不明点がございましたらカスタマーセンターにお問い合わせください。",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "商品受取時の封の状態（選択してください）",
  "分钟": "分",
  "FoodOpB_app_Need_to_eGSb": "ブランド認知度の強化が必要",
  "FoodC_popup_After_closing_ujoW": "ポップアップを閉じると、選択したオプションは保存されません。",
  "FoodC_remark_Enjoy_your_OvmD": "お食事をお楽しみください",
  "FoodOpB_management_Launching_HwsY": "開く",
  "GDriver_trans_seconds_fFsz": "秒",
  "FoodC_reasons_Enter_a_Pnzg": "具体的な理由を入力してください",
  "FoodB_audit_The_information_jxLV": "送信された情報は要件を満たしていません",
  "FoodB_optimizing_Duplicate_Store_aBYS": "重複店舗のID",
  "FoodC_education__4_QYXm": "(4) 現金支払い注文で、お客様が支払いを拒否した",
  "FoodB_V2_No_bank_plEI": "銀行口座情報なし",
  "FoodB_Show_Final_Tax_XQQi": "最終納税金額",
  "FoodC_education__3_ltNM": "（3） 配達員の手配ができないなどプラットフォーム側の原因、または外部の原因により注文がキャンセルされた場合",
  "FoodB_V2_Failure_to_sQaD": "契約要件未達",
  "FoodOpB_management_Indicator_description_kePF": "指標詳細",
  "FoodB_Show_Tax_payment_Dbuz": "納税方法（地域）",
  "FoodOpB_1_There_may_scoc": "訪問計画の時間に重複があります。当日の計画は以下の通りです：",
  "FoodOpB_1_Are_you_sLNY": "今回の訪問を中止しますか？中止すると訪問計画は失効となり入力できなくなります",
  "FoodC_all_No_reward_ocGJ": "ボーナスはありません",
  "FoodB_supplement_No_data_jUGB": "データがありません",
  "soda-c-i18n---联系商家": "店舗へ連絡",
  "FoodOpB_1_A_recent_LtIi": "最近の未完成訪問計画があります。入力を続けますか？",
  "FoodOpB_management_Weight_sGBg": "比重",
  "FoodB_optimization_Special_Meal_YtqD": "スペシャルプライス",
  "FoodB_Show_ID_Card_BrxO": "Cédula de Identidad",
  "FoodOpC_backend_Urban_hhdx": "都市",
  "FoodOpB_app_Need_to_XZYr": "オフラインの訪問が必要",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "昨日",
  "FoodD_Questionnaire_Finished_YvLk": "閉じる",
  "soda-c-i18n---早间：%s-%s": "早朝：%s-%s",
  "FoodD_Orders_Can_not_fkHK": "開始時間は終了時間より前に設定してください",
  "FoodD_payout_Company_Registration_zoVW": "法人番号（CJ）",
  "FoodB_data_Beginning_PbJC": "開始日",
  "FoodOpB_1_Visiting_Status_rbMX": "訪問ステータス",
  "FoodB_audit_Distance_between_BRSw": "新旧店舗間距離の差異",
  "FoodD_2_Income_Vqfp": "収入",
  "Fleet_tool_Search_sFMa": "検索",
  "FoodOpB_tagging_Non_retail_JnDS": "小売店ではない",
  "FoodOpC_system_Business_hours_coEs": "注文受付時間",
  "FoodOpB_tagging_You_chose_obli": "無効リーズの理由として「閉店」を選択しましたが、現在の位置は店舗から{{distance}}離れています。ご確認ください。",
  "FoodB_management_Business_hours_VLnY": "平日注文受付時間",
  "FoodC_education__1_mJTG": "(1) 店舗がすでに注文受付を確定した場合、「注文キャンセル」機能でキャンセルについて店舗に相談できます。すでに注文引き渡し済みなどの理由で店舗がキャンセルに同意しなかった場合、無料で注文をキャンセルすることはできません。それでも注文をキャンセル、または商品の受取を拒否した場合は発生した費用はすべてお支払いいただきます。",
  "FoodB_Show_Current_NJqK": "普通預金",
  "FoodB_optimization_Not_started_XTpL": "開始前",
  "FoodB_list_KP_Phone_qQCQ": "店長／店舗担当者電話番号",
  "FoodB_management_Store_association_coYB": "ブランド関連付け",
  "FoodOpB_crm_Business_model_wjXI": "ビジネスモード",
  "FoodB_list_KP_Name_GQRs": "店長／店舗担当者氏名",
  "FoodC_education_In_order_SRIb": "{{brand_name}}をご利用いただくお客様に、より良いご利用体験を提供するため、キャンセルに関するルールを設定させていただいております。",
  "FoodB_Show_Taxpayer_Document_eadz": "納税者証明書類タイプ（現地）",
  "FoodB_management_Automatic_closing_xRSd": "自動注文受付停止",
  "FoodOpB_center_Rejection_FiOu": "却下",
  "FoodC_sales_If_the_TsPm": "パッケージにテープや他の密封方法（ホチキスなど）がされていた場合、その止め具合を上記の選択肢から選択してください。この情報は店舗と配達員への事実確認にのみ使用されます。申立の結果には影響しません。",
  "FoodB_Analysis_Nearly_7_wumh": "直近{{day}}日間",
  "FoodB_2_During_the_QHhU": "キャンペーン期間",
  "FoodC_education__2_uVUK": "(2) 店舗の営業時間外、商品の在庫切れ、事故などの原因で店舗または配達員によって注文がキャンセルされた場合。ご注文代金はすべて払い戻しとなります。",
  "FoodB_orders_Select_Store_gtmG": "店舗を選択",
  "FoodB_audit_Suspected_duplicate_ntLx": "擬似重複店舗",
  "FoodOpB_1_Visit_today_hLhX": "本日訪問",
  "soda-c-i18n---提交申请": "注文をキャンセル",
  "FoodB_Show_Taxpayer_Document_TFeg": "納税者証明書類タイプ（全国）",
  "FoodOpB_v2_Type_BpqS": "操作タイプ",
  "FoodB_optimization_Buy_gifts_daUI": "注文するともらえる",
  "FoodC_revision_Less_meal_pHwq": "商品不足",
  "FoodB_system_Competition_NFPY": "競合での運営状況",
  "FoodB_management_Untied_tYEF": "連携解除",
  "FoodC_education__1_qvVC": "(1) お客様が時間内に受け取らなかった",
  "FoodC_method_Wait_keAM": "もう少し待つ",
  "FoodOpB_management_Corresponding_fractions_QlGf": "該当ポイント",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "お客様よりいただいたフィードバックは、今後のサービス向上のために役立ててまいります。",
  "FoodB_IV_Open_shop_xlhI": "自動注文受付開始",
  "FoodB_management_Sector_LRtz": "所属部署",
  "FoodOpB_crm_Takeaway_mode_UxEG": "配達モード",
  "FoodC_sidebar_Update_successfully_cuyI": "更新完了",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "最初桁は1でなければならず、11桁を入力する必要がある",
  "FoodOpB_Org_Add_at_nQez": "少なくとも1件の指標項目を追加してください",
  "FoodOpB_efficiency_Store_UpAc": "契約済み店舗数",
  "FoodB_Show_Special_residence_ezfV": "在留カード",
  "FoodB_audit_Click_OK_Zfsf": "確定をクリックすると",
  "FoodB_time_All_day_TIsU": "終日休業",
  "soda-c-i18n---将赔付给您1张%s折扣券": "遅延補填として%sの割引クーポンを1枚差し上げます",
  "soda-c-i18n---送您%s张免配送费券；": "%s枚の配達料無料クーポンを差し上げます。",
  "FoodB_supplement_Network_connection_RVcl": "ネットワークに接続されていません。ネットワークの設定を確認してください",
  "FoodB_tagging_You_chose_tIKm": "無効リーズの理由として「店舗が存在しない」を選択しましたが、現在の位置は店舗から{{distance}}離れています。ご確認ください。",
  "FoodOpB_1_Fill_in_QvuH": "訪問計画を入力",
  "FoodB_list_Apply_for_RxQn": "契約を申し込む",
  "soda-c-i18n---延迟送达%s分钟以上": "配達遅延%s分以上",
  "FoodOpB_1_Visit_dXVU": "訪問",
  "FoodB_leads_The_relationship_jkYA": "連絡のつきやすい時間",
  "FoodC_homepage_Search_for_CiMZ": "お店を探す",
  "FoodD_suspensionpage_In_the_zGEU": "以上",
  "FoodOpB_StoreInput_Store_Information_mIjy": "窓口ご担当者様",
  "FoodB_b_Source_of_qGPd": "参加方法",
  "FoodC_perception_Tip_exceeds_VSFf": "チップが上限額を超えています",
  "FoodB_V2_Satisfied_with_YFEM": "現状に満足している",
  "FoodB_202202_Minutes_tWiN": "分",
  "FoodC_education_Principles_of_RKEk": "受取時の問題対応の原則",
  "FoodB_tagging_You_chose_lWSH": "無効リーズの理由として「小売店ではない」を選択しましたが、現在の位置は店舗から{{distance}}離れています。ご確認ください。",
  "FoodC_details_Refund_Details_sGIk": "払戻詳細",
  "FoodC_education_Basic_requirements_hIbv": "ご注文受取の基本要件",
  "支付方式": "Payment Method",
  "FoodB_new1_Name_similarity_gepH": "名称類似度",
  "FoodD_Incentive_In_progress_GNvs": "進行中",
  "FoodB_2_Visit_Records_LiJy": "訪問記録",
  "FoodD_problem_I_see_NhGG": "了解しました",
  "FoodB_optimization_Contract_No_GvBj": "契約書番号",
  "FoodB_list_Online_Inspection_rExT": "登録確認項目",
  "FoodC_sales_Supplementary_information_ihyk": "追加情報",
  "FoodB_2_Planned_bPON": "計画中",
  "FoodB_store_Order_Coupon_zpSY": "注文完了でもらえるクーポン",
  "FoodC_education_In_the_nIgD": "以下のような注文キャンセルの場合は、お客様の責任となります。",
  "FoodC_dish_New_guest_bkGC": "初回注文限定",
  "FoodOpB_Home_Mandate_vafk": "タスク",
  "FoodC_education__2_KHhl": "(2) プラットフォームの規定時間内に受取地点に到着しなかった、お届け先住所の入力が間違っていた、受取番号が間違っていた、配達員の電話に応答しなかった、正当な理由なく商品の受け取りを拒否した場合は、ご注文代金をお支払いいただきます。",
  "FoodB_2_Call_visit_NGFu": "架電",
  "FoodB_management_Queries_dawh": "検索",
  "FoodB_I_Cancelled_orders_XeVk": "注文キャンセル件数",
  "FoodC_education_If_you_RTIV": "ご注文代金のお支払い完了後にキャンセルされる場合、以下のルールに従って対応いたします。",
  "FoodC_education_2_Receiving_gFZl": "2. お届け先住所、連絡先情報を正確に入力してください。",
  "FoodB_optimization_Stimulate_contact_xSSH": "希望連絡先",
  "FoodOpB_Org_Edit_Gphm": "編集",
  "FoodOpB_center_Action_MexV": "操作",
  "FoodB_Analysis_Decline_gSax": "-",
  "FoodOpB_1_Plan_Nfsn": "計画中",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_Commision_Cancel_wbtQ": "キャンセル",
  "FoodC_education_4_Customers_laxR": "4. 配達員が到着してから10分以内にご注文をお受け取り下さい。",
  "FoodOpB_Management_You_can_aDLi": "「申し立て」をタップすると新規店舗を作成できます。審査結果が出るまで2日ほどかかります。",
  "FoodOpB_OpsTasks_Off_GCPV": "中止",
  "FoodOpB_Org_Can_not_swrB": "削除すると元に戻せません。削除してもよろしいですか？",
  "优惠券": "クーポン",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "削除しました",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "実際の配達時間が予定配達時刻を%sから%s分遅れた場合、",
  "soda-c-i18n---送您1张%s折扣券；": "%sの割引クーポンを1枚差し上げます。",
  "FoodOpB_management_Actual_value_dSKC": "実際値",
  "FoodB_Analysis_Old_people_fwCy": "リピーター",
  "FoodOpB_app_Collecting_documents_wTBe": "書類送付中",
  "FoodOpB_Tool_Set_FrCO": "未設定",
  "soda-c-i18n---超时赔付规则说明": "遅延補填規則の説明",
  "FoodC_education__1_IIfh": "(1) 店舗の注文受付前に、注文詳細ページで「注文キャンセル」機能からキャンセルした場合",
  "支付": "支払う",
  "FoodB_IV_Tips_DFOG": "注意",
  "FoodD_messagemanagement_Mail_UMqH": "Eメール",
  "FoodOpB_Tool_Completed_MjfD": "完了",
  "FoodOpB_1_Visit_tomorrow_ptjT": "明日訪問",
  "FoodOpB_system_DiDi_ALAy": "DiDi契約状況",
  "FoodB_Analysis_Rise_decline_dZnP": "+",
  "FoodB_V2_No_store_ahBo": "店舗の納税者識別番号なし",
  "FoodC_education_In_the_MKeB": "以下のような注文キャンセルの場合は、お客様の責任になりません。",
  "FoodB_tagging_You_have_ssrJ": "無効リーズの理由として「小売店ではない」を選択する場合は、写真のアップロードまたはKP電話の入力が必要です。",
  "FoodB_audit_New_and_yYux": "新旧店舗名称の差異",
  "FoodOpB_tagging_Store_does_sduq": "店舗が存在しない",
  "FoodC_education_In_order_AZCw": "{{brand_name}}をご利用いただくお客様に、より良いご利用体験を提供するため、受取に関するルールを設定させていただいております。ご注文の受取について問題が発生した場合は、以下のルールに従って対応いたします。",
  "FoodOpB_Gattaran_Reset_ILVf": "クリア",
  "FoodB_Show_Special_Tax_Eidl": "特別納税者番号（NITE）",
  "FoodC_education__2_KZTZ": "(2) 配達員がお客様に連絡したが、連絡がつかなかった",
  "FoodB_leads_KP_Phone_hCUe": "KP電話番号2",
  "FoodOpB_APP_Visit_vdze": "訪問",
  "FoodB_new1_Similarity_ItET": "類似度",
  "FoodB_time_Business_hours_kRTs": "特別注文受付日時",
  "FoodD_h5_Single_quantity_lrNq": "注文完了数",
  "FoodOpB_1_New_Visiting_tIni": "訪問計画を作成",
  "FoodC_education_Cancellation_Policy_fxrl": "キャンセルルール",
  "FoodB_Analysis_New_customers_vYDl": "新規ユーザー",
  "FoodOpB_analysis_Performance_analysis_NMbA": "パフォーマンスデータ分析",
  "FoodOpB_set_Determination_wYFG": "確定",
  "FoodOpB_bill_Status_doqj": "公開状況",
  "FoodOpB_1_Closed_ieMb": "中止済み",
  "订单均价": "平均注文金額",
  "需要完善": "入力されてない箇所があります",
  "撤销申请": "申請を取り消す",
  "请先输入门店地址": "先に店舗の住所を入力してください",
  "请输入XXXXX-XXX": "XXXXX-XXXを入力してください",
  "合同类型": "契約書のタイプ",
  "默认": "デフォルト",
  "请补全营业时间": "営業時間未設定",
  "校准POI": "地点修正",
  "全部门店": "全ての店舗",
  "回收完成": "回収完了",
  "不支持": "利用しない",
  "暂停经营": "受付一時停止中です",
  "签约状态": "契約締結状態",
  "正常经营": "正常",
  "合作拜访结果": "提携訪問結果",
  "执照照片": "画像",
  "重复门店电话": "店舗の電話番号が重複しています",
  "添加营业时间段": "注文受付時間帯を追加",
  "暂无合作意愿": "今は提携の意向がありません",
  "合同基础信息": "契約基本情報",
  "请输入5位有效数字": "5桁の有効な数字を入力してください",
  "日常维护信息": "日常メンテナンス情報",
  "签字": "署名",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "提出後、承認過程中の情報修正はできませんが、提出しますか？",
  "证件号": "証明書番号",
  "请选择不合作原因": "提携しない理由を選択してください",
  "首次完单时间": "初回注文完了日時",
  "有限责任公司": "株式会社",
  "长期有效": "長期有効",
  "乙方注册地址": "登記住所：",
  "支行号": "支店番号",
  "暂无": "今はありません",
  "饮料店期间限定酒品贩卖准证": "料飲店等期限付酒類小売業免許",
  "请录入关闭原因": "クローズの理由を入力してください",
  "获取商圈中...": "ターゲットエリア取得中…",
  "土地使用许可证": "土地使用許可証",
  "周四": "木曜日",
  "重复门店": "店舗が重複しています",
  "普通商家": "一般店舗",
  "请在Gattaran上完成撤销申请！": "Gattaranで申請の取り消しを完了してください！",
  "距离": "店舗までの距離",
  "输入有误": "入力に誤りがあります",
  "设备信息": "設備情報",
  "不小于%d": "%d以上",
  "不愿完成": "設定希望なし",
  "申诉通道": "異議申し立てチャネル",
  "目前营业中门店": "営業中の店舗",
  "店主（法人）": "オーナー（法人代表者）",
  "未达到任务完成的标准": "タスク完了基準に達していません",
  "推迟发放": "発送延期",
  "必须为%d字": "%d字でお願いします",
  "担心外卖模式": "デリバリー方式が心配",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "複数の経営者が存在する場合、契約署名者または授権された契約署名者の氏名を入力しください",
  "提交成功！": "提出しました！",
  "授权书照片": "授権書の写真",
  "证号": "証明書の番号",
  "未完成PAD发放": "タブレット未発送",
  "有效商机数": "有効なターゲット店舗数",
  "法人CPF": "法人CPF",
  "工具": "ツール",
  "无相关信息": "関連情報はありません",
  "查看拜访记录": "訪問記録を確認します",
  "抽佣：": "手数料：",
  "工商登记时间": "商業登記日",
  "删除": "削除",
  "银行卡号": "キャッシュカード番号",
  "其他信息": "その他の情報",
  "起始时间": "開始時間",
  "未确定合作": "サイン未確定",
  "预计进行改善": "改善実施予定",
  "Curp号必须为18位字符": "Curp番号は18桁の文字となります",
  "不愿改善": "改善意向なし",
  "提交成功": "作成済み",
  "公司": "会社",
  "签约数据": "契約データ",
  "登记簿照片": "登記簿写真",
  "驳回原因": "却下理由",
  "电销团队": "テレマーケティングチーム",
  "城市": "都市",
  "完成时间": "完了日時",
  "发放时间": "アサイン日時",
  "放弃原因": "放棄理由",
  "KP电话:": "店長/店舗担当者 携帯番号:",
  "商机转交": "店舗タイプ相違/DiDi営業変更引継",
  "保存并发邮件&短信": "メールとショートメッセージを保存して送信",
  "签约授权书": "契約締結授権書",
  "信息已完善": "情報は完成しました",
  "完成PAD发放": "タブレット発送済み",
  "完成工作": "業務を完了します",
  "上拉加载更多": "スクロールしてさらに読み込む",
  "支付验证未通过": "口座認証が完了していません",
  "提交中": "作成中",
  "营业时间段": "営業時間帯",
  "等待原因": "待機理由",
  "平台配送及自配送不允许同时选择不支持": "DiDi配達と店舗配達は同時に選択できません",
  "平台管控中": "サービス提供時間外",
  "信心度A": "読みA",
  "任务完成标准": "タスク完了基準",
  "信心度B": "読みB",
  "信心度C": "読みC",
  "是": "はい",
  "同意上线": "オンラインに同意",
  "商户官网": "会社の公式サイト",
  "门脸照片": "店舗外観写真",
  "查看更多": "さらに確認",
  "KP CPF": "KP CPF",
  "门店电话:": "店舗の電話番号:",
  "新建商机成功": "ターゲット店舗の新規作成成功",
  "添加拜访计划": "訪問計画を追加します",
  "评分": "評価",
  "营业执照照片": "営業許可書写真",
  "法人名片假名": "代表者 名カナ",
  "驾照": "運転免許証",
  "我的拜访": "私の訪問",
  "个人信息": "個人情報",
  "订单量": "注文数",
  "居民证明": "住民票の写し",
  "确认签章": "署名押印を確認します",
  "合作拜访": "提携店舗獲得",
  "拜访记录": "訪問記録",
  "无合作意向": "加盟意向なし",
  "董事": "取締役",
  "有效期": "有効期",
  "周三": "水曜日",
  "PAD型号": "タブレットモデル",
  "乙方名称片假名": "契約事業者名称",
  "高端饭店": "高級レストラン",
  "是否已经加入其他外卖平台？": "その他のデリバリープラットフォームに既に加入していますか？",
  "周一": "月曜日",
  "点击查看原因": "クリックして理由を確認",
  "开户行": "銀行名",
  "去修改": "変更する",
  "KP电话是店长账户": "店長の携帯番号は店舗操作用のアカウントになります",
  "确认要清空搜索记录吗？": "検索記録を削除しますか？",
  "点击收起": "クリックして閉じる",
  "暂停营业中": "受付一時停止中",
  "状态机": "ステータス",
  "暂无数据": "データがありません",
  "拜访详情": "訪問詳細",
  "周日": "日曜日",
  "启动费": "初期費用",
  "疑似CKA": "疑似CKA",
  "选择职位": "役職を選択",
  "已关闭": "クローズしました",
  "CNPJ": "CNPJ",
  "KP姓片假名": "店長/店舗担当者 姓カナ",
  "提交人": "提出者",
  "签约信息": "契約締結情報",
  "审核中": "審査中",
  "有效": "有効",
  "CKA BD": "CKA BD",
  "确定删除吗？": "削除しますか？",
  "请输入半角片假名": "半角カナで入力してください",
  "日常工具": "お気に入り",
  "正常": "正常",
  "请选择无意愿原因": "意向のない理由を選択してください",
  "（多选）": "(複数選択)",
  "上一步": "戻る",
  "掉线中": "ネットワーク中断",
  "周五": "金曜日",
  "沟通经营问题（服务管控+店铺装修）": "改善コンサルティング（サービスコントロール+店舗改装）",
  "执行人": "実行者",
  "填写拜访备注可供后续跟进参考": "今後のフォローアップの参考のために訪問についての備考を入力します",
  "扣费次数大于等于1": "控除回数は最低1回以上 ",
  "梅斯卡尔酒": "メスカル酒",
  "线下": "訪問",
  "效率": "効率",
  "帐户持有人CPF": "口座名義人CPF",
  "商户运营": "店舗運営",
  "无效商机": "店舗無効（閉店・休業・重複など）",
  "拜访历史": "訪問履歴",
  "菜单照片": "店内メニューの写真",
  "去设置": "設定する",
  "封禁中": "ブロック中",
  "跟进中": "フォローアップ中",
  "销量(单/周)：": "注文数（件/週）",
  "支持以下哪种支付方式": "以下対応可能な支払方法をお選びください",
  "原因": "理由",
  "CPF号必须为11位数字": "CPF番号は11桁の数字となります",
  "周二": "火曜日",
  "保存": "保存",
  "商户号": "会社法人等番号",
  "参加": "参加",
  "失败号": "エラー番号",
  "万": "万",
  "谷歌地图": "グーグルマップ",
  "打开浏览器失败": "ページを開けません",
  "乙方联系方式": "乙の連絡方法",
  "银行卡号仅支持数字输入": "キャッシュカード番号は数字のみで入力してください",
  "加价限制（%）": "値上げ制限（%）",
  "上传交付照片": "アップロードして写真を提出する",
  "商户主体类型为公司时需提供此项内容": "店舗主体タイプが法人の場合入力必須（12桁、登記簿に記載がある番号）",
  "佣金补贴周期": "手数料補助のサイクル",
  "沟通新店保护设置": "新規加盟店サポート設定について",
  "公共契约编号": "公的契約番号",
  "编辑经营信息": "経営情報の編集",
  "首次完成开店检查时间": "初回開店審査完了日時",
  "已签约": "契約締結済み",
  "开户公司CNPJ": "口座名義CNPJ　",
  "商家概况": "店舗概要",
  "执行团队": "実行チーム",
  "未连接到服务器": "サーバーに接続されていません",
  "门店信息": "店舗情報",
  "当前数据计算至:": "算出されたデータは以下の通りです：",
  "KP CPF照片": "KP CPFの写真",
  "自配送起送费": "店舗配達の最低配達金額",
  "电话号码不对": "廃番/番号相違",
  "店长": "店長",
  "已完成培训": "トレーニング完了",
  "不限": "制限なし",
  "品牌授权书": "ブランド授権書",
  "P1": "P1",
  "请输入3位有效数字": "3桁の有効な数字を入力してください",
  "我知道了": "はい",
  "P0": "P0",
  "考虑中": "検討中",
  "P2": "P2",
  "Curp号": "Curp番号",
  "已归档": "アーカイブ済み",
  "是否需要pad": "padが必要ですか？",
  "点击校准": "クリックして校正する",
  "转让": "譲渡",
  "附件照片": "添付写真",
  "%s级": "%s クラス",
  "人工标记平台：": "競合他社利用状況(手動入力)",
  "审核通过商户数": "審査を通過した店舗数",
  "自入驻": "セルフ登録",
  "老版无Curp": "旧バージョン、Curpなし",
  "老版有Curp": "旧バージョン、Curpあり",
  "首页": "トップページ",
  "店内环境": "店内イメージ",
  "详细原因": "詳細理由",
  "商机无效": "ターゲット店舗無効",
  "金酒": "ジン",
  "未完成": "未完了",
  "支付验证": "口座認証",
  "返回": "戻る",
  "请输入7位有效数字": "7桁の有効な数字を入力してください",
  "账号无法登陆": "アカウントにログインできません",
  "签字授权书": "授権書",
  "无效原因": "無効の理由",
  "持卡人地址": "カード名義人住所",
  "拜访备注": "訪問の備考",
  "标记问题门店": "問題店舗タグ付与",
  "纳税照片": "納税写真",
  "建议拍摄店面照片": "店舗正面の写真を推奨します",
  "已完善": "入力完了",
  "指定": "指定",
  "标题": "題名",
  "不承诺": "承諾しません",
  "发起者": "作成者",
  "不能超过%d字": "%d文字以内にしてください",
  "佣金补贴比例": "手数料補助の割合",
  "放弃": "放棄",
  "请选择营业天数": "営業曜日を選択してください",
  "抽佣问题": "手数料が高い",
  "合法代表": "法人代表者",
  "KP名": "店長/店舗担当者 名",
  "自定义": "自由編集",
  "单次最大扣费金额": "1回あたりの最大控除金額",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "店舗主体タイプが法人の場合入力必須（13桁、国税庁公表した法人番号）",
  "持卡人姓": "カード名義人の姓",
  "单次最大扣费金额(MX$)": "1回あたりの最大控除金額（日本円）",
  "重复门店名称": "店舗名が重複しています",
  "KP姓名": "KP氏名",
  "请输入门店ID": "ショップIDを入力してください",
  "IMEI": "IMEI",
  "负责人表示不合作": "責任者／本社NG",
  "售卖时间": "営業時間",
  "是否有异常标签": "エラータグの有無",
  "去升级": "アップデートする",
  "是否有违规记录": "特商法違反・消費者契約法違反歴",
  "审批通过": "認証されました",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "本ページのスクリーンショットをdidi@didichuxing.comに送信すると、本部の担当者が検証し、7日以内に異議申し立ての結果をフィードバックします。",
  "上传最大数量为%d张，图片上限为5MB": "アップロード可能な最大枚数は%d枚で、画像のサイズ上限は5MBです",
  "银行代理number": "銀行代理number",
  "银行代理digit": "銀行代理digit",
  "巴西": "ブラジル",
  "地区": "地域",
  "捡入": "セレクト",
  "门店logo": "店舗ロゴ",
  "商家不愿培训": "トレーニング意向なし",
  "审核中商户数": "審査中の店舗数",
  "银行": "銀行",
  "线上支付": "オンライン支払い",
  "竞品独家签约": "競合サービスと独占契約あり",
  "已完成设置": "設定完了",
  "已添加": "追加済み",
  "复制成功": "コピー成功",
  "总评价人数": "全評価人数",
  "周六": "土曜日",
  "愿意改善": "改善希望",
  "门店电话": "店舗の電話番号",
  "标红信息即可完成添加": "情報を赤くマークすると、追加が完了します",
  "疑似CKA/KA": "疑似CKA/KA",
  "首次有效上线时间": "初回有効オンライン日時",
  "My Number卡": "マイナンバー（個人番号）カード",
  "设备回收": "設備回収",
  "执行者": "実行者",
  "补充照片": "写真を追加します",
  "再次尝试电话联系": "本社決裁（後日フォロー予定なし）",
  "填写拜访": "営業活動記録",
  "法人CPF照片": "法人CPFの写真",
  "门店POI不能为空": "店舗POIは空にできません",
  "待办事项": "処理待ち事項",
  "商机信息": "ターゲット店舗の情報",
  "预计休业": "休業中／休業予定",
  "Pad": "Pad",
  "经营状态": "経営状況",
  "其他筛选": "他のフィルタ",
  "是否自配送：": "店舗配達ですか？",
  "当前定位失败": "現在地の検出に失敗しました",
  "与KP完成沟通即视为有效拜访": "KPとコミュニケーションが完了すると、有効な訪問と見なされます",
  "优先级": "優先順位",
  "任务来源": "タスクソース",
  "快速拍摄": "クイック撮影",
  "设备故障": "設備の故障",
  "菜单信息": "店内メニュー情報",
  "出生日期": "生年月日",
  "自配送费": "店舗配達料金",
  "（创建超级管理员账号）": "（マスター管理者のアカウント作成用）",
  "可提现金额：": "現金化できる金額：",
  "请输入": "入力してください",
  "法人姓": "代表者 姓",
  "自配送订单量（单/周）": "店舗配達の注文数（件/週）",
  "审核完成": "審査が完了しました",
  "朗姆酒": "ラム酒",
  "店员": "従業員",
  "冻结金额：": "停止中の金額：",
  "签约状态：": "契約締結状態：",
  "合同记录": "契約書の記録",
  "待办任务": "完成待ちタスク",
  "时间格式错误": "時間のフォーマットエラー",
  "审批失败": "審査失敗",
  "确定合作": "内諾済み",
  "啤酒": "ビール",
  "（商家接收邮件）": "（店舗受信用メールアドレス）",
  "已首次上线商户数": "初回オンライン掲載済みの店舗数",
  "不想使用外卖模式": "デリバリーを利用したくない",
  "接收电子合同的邮箱": "契約書は契約者のメールアドレスに送付されます",
  "一般酒精产品贩卖准证": "一般酒類小売業免許",
  "门店照片": "店舗写真",
  "请选择": "選択してください",
  "营业时间段不能重叠": "営業時間帯は重複出来ません",
  "有特殊情况不能上线": "特別な事情によりオンライン不可",
  "门店PAD信息": "店舗タブレット情報",
  "电话预约": "アポ取り／電話商談",
  "选择商圈": "ターゲットエリアを選択",
  "KA": "KA",
  "结束时间": "終了時間",
  "确认银行卡号": "キャッシュカード番号を確認します",
  "商户调研": "リサーチ",
  "在留卡": "在留カード",
  "访谈&调研": "面談とリサーチ",
  "葡萄酒": "ワイン",
  "承诺": "承諾する",
  "推迟": "まだ検討中です",
  "实际上线商户数": "実際の注文受付店舗数",
  "再次申请": "再申請",
  "自配送佣金比例": "店舗配達の手数料の割合",
  "门店地址": "店舗住所",
  "推荐完成": "推薦完了",
  "暂不支持复制功能": "現在コピー機能はサポートされていません",
  "拜访内容": "訪問内容",
  "不能为空": "必ず入力してください",
  "暂停营业": "受付一時停止中です",
  "活期": "当座",
  "提案失败": "提案失敗",
  "创建时间": "作成日時",
  "过期拜访": "延滞訪問",
  "经营信息": "経営情報",
  "依据门店POI反解": "店舗POIによる位置情報取得",
  "刷新成功": "更新成功",
  "解约": "解約",
  "拜访结果": "訪問結果",
  "价格承诺": "価格の承諾",
  "电子合同": "電子契約",
  "KP电话": "店長/店舗担当者 携帯番号",
  "乙方联系人姓": "署名者 姓",
  "银行卡号必须为18位": "キャッシュカード番号は18桁となります",
  "不愿配合": "協力意向なし",
  "银行流水单": "銀行口座確認画像",
  "储蓄": "普通",
  "首位必须是1，必须输入11位": "1で始まる、11桁の数字となります",
  "是否需要拍照": "写真撮影サービスの希望",
  "无银行账号": "銀行口座番号がありません",
  "请输入13位有效数字": "13桁の有効な数字を入力してください",
  "KP所属部门": "店長/店舗担当者 所属部署",
  "LTE": "LTE",
  "PAD领取人": "タブレット受取人",
  "银行名称": "金融機関名",
  "成功留存": "リテンション成功",
  "确定": "確定",
  "金额": "金額",
  "待领取": "受付待ち",
  "停止营业": "閉店",
  "伏特加": "ウォッカ",
  "暂时不愿上线": "現在オンライン意向なし",
  "合作谈判": "商談",
  "KP姓名:": "KP氏名:",
  "沟通经营问题": "改善コンサルティング",
  "商机详情": "ターゲット店舗の詳細情報",
  "支持": "利用する",
  "请输入正确的邮箱地址": "正確なメールアドレスを入力してください",
  "信息未完善": "情報は未完成です",
  "CPF": "CPF",
  "确认要退出吗？": "ログアウトしますか？",
  "查看": "確認",
  "乙方联系人": "署名者",
  "证件照片": "本人確認書類画像",
  "税号": "法人番号",
  "促进商户首次上线": "ファーストオンライン促進",
  "公证编号和地区": "公証番号と地区",
  "语言": "言語",
  "登录商户账号": "店鋪の口座番号を登録",
  "未联系到关键目标": "決裁者と接触できず",
  "后续陌拜": "後日再度架電／再訪問",
  "任务类型": "タスクタイプ",
  "打款授权书": "支払授権書",
  "营业时间": "営業時間",
  "持卡人名": "カード名義人名",
  "电话培训": "電話トレーニング",
  "通过时间": "認証通過時間",
  "请输入银行名称或五十音": "金融機関名を検索",
  "联系不上": "連絡つかず",
  "编辑商机": "ターゲット店舗の編集",
  "拜访时间": "訪問時間",
  "指已签约并且上线接单的门店": "契約締結済みで注文受付開始店舗を指します",
  "线下店铺菜单": "店内メニューの写真",
  "无多余人力": "余分な人手がありません",
  "格式错误": "フォーマットエラー",
  "纸质合同": "書面の契約書",
  "合同生效日期": "契約書の発効日",
  "分发失败": "分配失敗",
  "保存草稿": "下書きを保存",
  "账号": "口座番号",
  "接收人": "受領者",
  "円": "円",
  "使用此功能需升级至最新版本": "この機能を使用するためには、最新バージョンに更新する必要があります",
  "无多余人力(过于繁忙)": "人員不足（多忙のため）",
  "预计参加：店铺配置": "参加予定：店舗設定",
  "WIFI": "WiFi",
  "任务分发": "タスク分配",
  "无效": "無効",
  "乙方联系人名片假名": "署名者 名カナ",
  "ESC": "ESC",
  "应上线商户数": "受付すべきテナント数",
  "结算信息": "銀行口座情報",
  "(R$)": "(R$)",
  "关于": "関連情報",
  "设置": "設定",
  "担心配送质量": "配達のサービス品質が心配",
  "无法获取手机定位，请检查": "携帯電話の位置情報が取得できません。確認してください",
  "数值只能是%s位小数": "数値は小数点以下%sまでお願いします",
  "上传最大数量为3张，图片上限为5M": "アップロード可能な最大枚数は3枚で、画像のサイズ上限は5Mです",
  "CKA": "CKA",
  "佣金审核证明": "手数料の審査証明",
  "范围": "範囲",
  "录入合同基础信息": "契約基本情報の入力",
  "未见KP": "KPに面会していません",
  "公司公证": "会社公証",
  "审核通过": "審査を通過しました",
  "查看申请": "申請を確認",
  "未签约": "契約未締結",
  "申请签约": "契約締結の申請",
  "已校准": "済み",
  "审核结束": "審査が終了しました",
  "不参加": "不参加",
  "不保存": "保存しません",
  "酒精销售许可证": "酒類販売業免許",
  "具备上线能力商户数": "注文受付可能な店舗数",
  "邮编": "郵便番号",
  "手机和座机都只支持10位数字": "携帯電話と固定電話はいずれも10桁または11桁の数字のみをサポートします",
  "手机号": "携帯電話番号",
  "不允许特殊字符": "特殊文字は使用できません",
  "KP姓": "店長/店舗担当者 姓",
  "店内桌数（桌）": "店内のテーブル数（卓）",
  "待提交": "提出待ち",
  "疑似KA": "疑似KA",
  "附件说明": "添付ファイルの説明",
  "是否有效拜访": "有効な訪問ですか？",
  "完成培训": "トレーニング完了",
  "查看示例": "例を確認",
  "请输入有效的门店id": "有効なshopidを入力してください",
  "工商登记号码": "商業登記番号",
  "持卡人姓名": "カード名義人氏名",
  "系统标记平台：": "競合他社利用状況",
  "其他": "その他",
  "人工标记平台": "競合他社利用状況(手動入力)",
  "品牌名称": "ブランド名",
  "去填写": "記入する",
  "选择日期": "日付を選択",
  "必须为%d或%d字": "%dまたは%d字でお願いします",
  "待办理": "処理待ち",
  "重复门店ID": "店舗IDが重複しています",
  "账户状态：": "アカウントのステータス：",
  "设备铺设结果": "設備の取り付け結果",
  "工商登记注册地": "商業登記場所",
  "白兰地": "ブランデー",
  "数据": "データ",
  "上传失败，请重新上传": "アップロード失敗。再度アップロードしてください",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "添付ファイルをアップロードできます。重要な情報を含むページは個別に写真を撮り、【免許証写真】にアップロードする必要があります",
  "签约中": "契約締結中",
  "不需要pad": "DiDiタブレットは不要です",
  "复制": "コピー",
  "商户签约": "店舗契約",
  "乙方邮箱": "契約署名者メールアドレス",
  "无营业资质": "デリバリー対象外",
  "活跃程度": "アクティブレベル",
  "高端饭店不做外卖": "高級レストランはデリバリーをしません",
  "最多%d个": "最大%d個",
  "找不到店": "店舗が見つかりません",
  "提交开店申请商户数": "開店申請を提出した店鋪数",
  "不合作原因": "提携しない理由",
  "合同编号": "契約書番号",
  "门店POI": "地点詳細確認",
  "开店信息": "開店情報",
  "商家开店检查": "店舗出店審査",
  "关联品牌名称": "関連ブランド名",
  "门店距离": "店舗までの距離",
  "KP电话（仅支持手机）": "店長/店舗担当者 携帯番号",
  "关联签约主体名称": "関連契約主体名",
  "门店名称": "店舗名",
  "陪访人": "同行者",
  "银行账户digit": "銀行口座番号桁数",
  "营业时间不能重复设置": "営業時間は重複して設定することは出来ません",
  "法人姓片假名": "代表者 姓カナ",
  "成功": "成功",
  "开始时间": "開始時間",
  "纳税信息": "納税情報",
  "审批邮件": "認証メール",
  "完善以下": "以下を完成させてください",
  "乙方联系人手机": "ご契約者様携帯電話番号",
  "门店品类": "店舗のカテゴリー",
  "运营数据": "運営データ",
  "新建商机": "ターゲット店舗の新規作成",
  "任务基础信息": "タスク基本情報",
  "食堂订单量（单/周）": "店鋪の注文数（件/週）",
  "30天后解约": "30日後解約",
  "新版": "新版",
  "上传照片不能超过%dMB，请重新上传": "アップロードできる画像のサイズ上限は%dMBです。もう一度アップロードしてください",
  "需要": "必要",
  "佣金策略合同模板": "手数料戦略契約書テンプレート",
  "任务详情": "タスク詳細",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "電話番号に入力可能な文字は数字、英文コンマです。その他の記号を入力した場合は提出できません",
  "您当前的网络环境不太好": "現在のネットワーク環境はあまりよくありません",
  "预计参加：DiDi配置": "参加予定：DiDi設定",
  "审核失败": "審査失敗",
  "请选择等待原因": "待機の理由を選択してください",
  "模式选择": "モデルの選択",
  "商圈": "ターゲットエリア",
  "类型": "タイプ",
  "信息尚未保存，是否保存？": "情報はまだ保存されていません。保存しますか？",
  "请选择接收人": "受領者を選択してください",
  "启动费太高": "初期費用が高い",
  "股份有限公司": "株式会社",
  "加价限制": "値上げ制限",
  "获得初步意向": "アポ獲得",
  "任务ID": "タスクID",
  "乙方联系人头衔": "役職名",
  "不确定合作意向": "契約意向未定",
  "处理时间": "操作日時",
  "打款": "支払",
  "资质类型": "種類",
  "添加营业时间": "注文受付時間を追加",
  "门店价值": "店舗ランク",
  "编辑": "編集",
  "CNPJ号必须为14位数字": "CNPJ番号は14桁の数字となります",
  "请输入半角片假，不能超过48个字符": "半角カナで入力してください, 48文字以内にしてください",
  "回收pad": "タブレットの回収",
  "当前位置距商家": "現在位置から店舗まで",
  "商家是否在线：": "店舗注文受付がオン：",
  "商家信息": "店舗情報",
  "护照": "パスポート",
  "发起验证申请": "口座認証申請",
  "银行账户number": "銀行口座番号",
  "请填写真实原因": "本当の理由を記入してください",
  "不能超过%d": "%d以内にしてください",
  "自配送范围及时长": "店舗配達の範囲および時間",
  "公证日期": "公証日",
  "市政经营许可证": "営業許可書",
  "已签章": "署名捺印済み",
  "至": "まで",
  "图片": "画像",
  "未完善": "入力未完了",
  "打烊中": "受付時間外",
  "商户留存措施": "チャーン防止対応",
  "菜单": "メニュー",
  "下一步": "次へ",
  "自配送": "店舗配達",
  "正式拜访": "着座商談",
  "具备上线能力": "注文受付可能",
  "失败原因详情": "失敗理由詳細",
  "金额(円)": "金額（円）",
  "金额(MX$)": "金額（円）",
  "土地使用许可证执照照片": "免許証の写真",
  "签约": "契約締結",
  "任务": "タスク",
  "首次完成签约时间": "初回契約完了日時",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "現在の店舗総数=契約未締結の店舗+契約締結中の店舗+契約締結済みの店舗",
  "平台配送最低服务费": "DiDi配達の最低サービス料",
  "上传最大数量为%d张，图片上限为%dM": "アップロード可能な最大枚数は%d枚で、画像のサイズ上限は%dMです",
  "法人名": "代表者 名",
  "系统标记平台": "競合他社利用状況",
  "个人": "個人事業",
  "请选择无效拜访原因": "訪問無効の理由を選択してください",
  "过于繁忙": "多忙のため",
  "确定合作，准备收集资料": "内諾獲得",
  "日本": "日本",
  "上传最大数量为1张，图片上限为5MB": "アップロード可能な最大枚数は1枚で、画像のサイズ上限は5MBです",
  "乙方联系方式是超级管理员账户": "契約者の携帯番号はスーパー権限アカウントになります",
  "若证件类型选择“老版无Curp”，需上传补充附件": "証明書のタイプで「旧バージョン、Curpなし」を選択した場合、補足の添付ファイルをアップロードする必要があります",
  "拜访方式": "営業活動タイプ",
  "选择城市": "都市を選択",
  "退出登录": "ログアウト",
  "日常提醒商家上线": "日常的なオンラインアラート",
  "乙方联系人名": "署名者 名",
  "乙方联系人姓片假名": "署名者 姓カナ",
  "回收未完成": "回収未完了",
  "有效在线商户数": "有効な注文受付中店鋪数",
  "上传最大数量为1张，图片上限为5M": "アップロード可能な最大枚数は1枚で、画像のサイズ上限は5Mです",
  "千": "千",
  "歇业中": "受付休止中",
  "基础信息": "基本情報",
  "销售电话": "担当営業の電話番号",
  "重复门店与创建门店的距离": "新規店舗と重複した店舗の間の距離",
  "签约%d周后": "契約締結から%d週間後",
  "乙方联系人CPF": "乙の担当者CPF",
  "门店": "店舗",
  "照片": "写真",
  "全部区域": "全エリア",
  "法人姓名": "代表者 姓",
  "拆迁": "移転",
  "请选择失败原因": "失敗の理由を選択してください",
  "营业信息": "店舗基本情報",
  "添加电话": "電話番号を追加",
  "搜索记录": "検索記録",
  "门店地址片假名": "店舗住所カナ",
  "打开地图失败": "マップを起動できません",
  "未添加": "未追加",
  "加载中": "読み込み中",
  "请输入12位有效数字": "12桁の有効な数字を入力してください",
  "商家位置": "店舗の位置は",
  "不愿上线": "オンライン意向なし",
  "开始扣费时间": "費用控除開始時間",
  "CKA/KA BD": "CKA/KA BD",
  "我负责的": "私の担当",
  "平台配送": "DiDi配達",
  "KP邮箱": "店長/店舗担当者 メールアドレス",
  "封禁": "ブロック",
  "合同信息": "契約書情報",
  "完成电话": "実施済み",
  "卫生安全通知": "食品衛生に関する通知",
  "乙方名称": "契約事業者名称",
  "账号名称": "口座名義",
  "现金支付": "現金払い",
  "座机": "固定電話",
  "更新时间": "更新日時",
  "乙方联系人CPF照片": "乙の担当者CPFの写真",
  "标准合同模板": "標準契約書テンプレート",
  "许可证有效期": "許可証の有効期限",
  "还在考虑，需要追客": "検討中、後日再度架電／訪問",
  "签约状态（多选）": "契約状態（複数選択）",
  "支行名称": "支店名",
  "12位数，法人登记簿上的号码": "12桁、登記簿に記載がある番号",
  "门店ID": "店舗ID",
  "提交材料": "送信",
  "失败原因": "失敗理由",
  "无法联系到KP": "KPに連絡できません",
  "授权人": "授権者",
  "手机": "携帯電話",
  "请在Gattaran查看": "Gattaranで確認してください",
  "被授权人证件照片": "被授権者の本人確認書類画像",
  "希望解约/回收pad": "解約希望/タブレット回収",
  "乙方联系方式（仅支持手机）": "乙の連絡方法（携帯電話のみをサポート）",
  "附件类型": "添付ファイルのタイプ",
  "计划完成设置": "設定予定",
  "请输入XXX-XXXX": "入力してくださいXXX-XXXX",
  "我的新增": "新規追加",
  "有合作意向": "提携意向があります",
  "KP名片假名": "店長/店舗担当者 名カナ",
  "没联系到": "連絡つかず",
  "非餐饮": "非飲食",
  "不需要": "不要",
  "附件文件": "添付ファイル",
  "法人信息": "代表者情報",
  "已拜访商机数": "既に訪問したターゲット店舗数",
  "点击上传": "クリックしてアップロード",
  "扣费次数": "請求分割回数",
  "培训使用方法": "トレーニング方法",
  "陌拜": "飛び込み",
  "仅支持数字输入": "数字のみ入力可能です",
  "铺设失败": "取り付けに失敗しました",
  "任务完成": "タスク完了",
  "复制链接": "リンクをコピー",
  "已完成": "完了済み",
  "已完成改善": "改善済み",
  "扣费比例": "控除の割合",
  "预定上线": "オンライン予定",
  "草稿中": "下書き保存中",
  "没有更多数据了": "これ以上データはありません",
  "未知": "不明",
  "提交": "提出",
  "否": "いいえ",
  "填写拜访信息": "訪問情報を入力します",
  "商户主体类型": "店舗の運営タイプ",
  "新功能培训": "新機能トレーニング",
  "详细录入规则": "詳細入力ルール",
  "不再发放": "発送中止",
  "门店详情": "店舗の詳細",
  "经营品类": "取り扱い商品のカテゴリー",
  "提交时间": "提出時間",
  "待定": "未定",
  "完单量": "注文完了数",
  "担心外卖模式(不想使用外卖模式)": "デリバリーに不安を感じる（デリバリーを利用したくない）",
  "乙方注册地址邮编": "登記住所の郵便番号：",
  "登记簿": "登記簿",
  "营业执照": "営業許可書",
  "账户余额：": "アカウントの残高：",
  "备注": "備考",
  "不在线": "受付がオフになっています",
  "结算信息照片": "決済情報の写真",
  "价格信息": "価格情報",
  "证件类型": "本人確認書類種別",
  "提交后将无法正常签约": "提出しますと、正常に契約締結ができなくなります",
  "威士忌": "ウイスキー",
  "在线": "注文受付中",
  "销售姓名": "担当営業の氏名",
  "铺设成功": "取り付けに成功しました",
  "催促商家首次上线": "ファーストオンラインの促進",
  "合同照片": "契約書の写真",
  "对公": "法人向け",
  "商户运营价值": "ショップランク",
  "米": "メートルです",
  "创建失败": "開設失敗",
  "龙舌兰酒": "テキーラ",
  "已核准": "承認済み",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "署名押印を確認するには、契約書の添付文書をアップロードする必要があります。Gattaranで完了してください！",
  "提交至审批": "提出済み、承認待ち",
  "在线状态：": "注文受付状態:",
  "资质信息": "資格情報",
  "物料发放": "アイテム発送",
  "姓名": "氏名",
  "Opening Call": "Opening Call",
  "两次银行卡号不一致！": "確認用の口座番号が一致しませんでした！",
  "取消": "キャンセル",
  "法人证件": "代表者証明書",
  "编辑商机成功": "ターゲット店舗編集成功",
  "拜访对象": "面会者お名前",
  "营业中": "注文受付中",
  "门店营业时间": "店舗の営業時間",
  "无法获取应用版本信息": "アプリのバージョン情報が取得できません",
  "商家位置为": "店舗の位置は",
  "Curp号必须为大写字母": "Curp番号は全て大文字のアルファベットとなります",
  "请输入数字": "数字を入力してください",
  "全部": "全部",
  "活动招商": "プロモーション提案",
  "墨西哥": "メキシコ",
  "资料录入": "書類入力",
  "地区与语言": "地域と言語",
  "平台配送佣金比例": "DiDi Food配達時手数料",
  "取消订单量": "注文キャンセル数",
  "待完成": "未完了",
  "电话": "電話番号",
  "请输入门店名称搜索": "店舗名を入力して検索してください",
  "当前门店总数": "現在の店舗総数",
  "开户公司名": "口座名義",
  "已签约商户数": "契約締結済みの店舗数",
  "日常维护": "日常メンテナンス",
  "合同版本": "契約書のバージョン",
  "商机价值": "リードランク",
  "联系方式": "ご連絡先",
  "选项和输入框不能为空": "選択欄と入力欄を埋めてください",
  "邮件&短信已发送给商家": "メールとショートメッセージを送信しました",
  "管控状态：": "コントロール状態：",
  "审批中": "認証中",
  "您提交的无效原因有误，请检查": "提出した無効な理由が間違っています。確認してください",
  "本模块支持上传文件，可至PC端操作": "本モジュールはファイルのアップロードをサポートしており、PC端末で操作できます。",
  "拜访目标": "訪問目的",
  "门店类型": "店舗のタイプ",
  "创建成功": "開設成功",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "銀行口座認証しますか？【口座認証】を申請するには【確定】をタップ",
  "账户类型": "口座種別",
  "KA BD": "KA BD",
  "发送邮件&短信": "メールとSMSを送信",
  "正常门店": "正常な店舗",
  "设备铺设": "設備の取り付け",
  "门店名称片假名": "店舗名カナ",
  "销售数据": "売上データ",
  "乙方注册地址片假名": "登記住所カナ",
  "请选择无效原因": "無効の理由を選択してください",
  "对私": "個人向け",
  "个人企业": "個人事業"
}